import { closeDrawerPane } from 'owa-drawer';
import { flexPaneClosed } from 'owa-suite-header-apis';
import { setIsFlexPaneShown } from 'owa-suite-header-store';

export default function closeHeaderPane(paneId: string, targetWindow?: Window) {
    closeDrawerPane(paneId, targetWindow);
    setIsFlexPaneShown(paneId, false);
    flexPaneClosed(paneId);
}
